import type { Theme } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { SxProps } from '@mui/system'
import { Link, matchPath, useLocation } from 'react-router-dom'

const sxTabs: SxProps<Theme> = (theme) => ({
  marginLeft: theme.spacing(2),
  marginBottom: '-1px',
  border: 'none',
  background: 'none',
  ['.MuiTabs-indicator']: {
    display: 'none',
  },
})

const sxTab: SxProps<Theme> = (theme) => ({
  textTransform: 'uppercase',
  minHeight: 76,
  border: 'none',
  ['&:hover']: {
    color: theme.palette.common.black,
  },
  ['&.Mui-selected']: {
    background: theme.palette.customGrey.lighter,
  },
  ['&.Mui-disabled']: {
    color: theme.palette.common.black,
  },
})

export const TopNav = () => {
  const location = useLocation()

  const matchesHome = matchPath({ path: '/', end: true }, location.pathname)

  // TODO: I think that tabs actually are not the correct component here
  // maybe Toolbar with just links?
  return (
    <Tabs
      sx={sxTabs}
      value={matchesHome ? '/' : '/assessment'}
      aria-label="Navigation"
      role="navigation"
    >
      <Tab sx={sxTab} to="/" label="Aufträge" value="/" component={Link} />
      {!matchesHome && (
        <Tab
          sx={sxTab}
          disabled
          label="Assessment"
          value="/assessment"
          component="span"
        />
      )}
    </Tabs>
  )
}
